<ng-container *ngIf="showSkeleton; else additionalInfoContent">
  <div class="pod-skeleton">
    <div class="pod-skeleton__title"></div>
    <div class="pod-grid">
      <div class="pod-skeleton__bar pod-skeleton__bar--full"></div>
      <div class="pod-skeleton__bar pod-skeleton__bar--textarea"></div>
    </div>
  </div>
</ng-container>

<ng-template #additionalInfoContent>
  <div class="pod-section" [formGroup]="form">

    <h2 class="pod-section__title">{{ sectionLabel }}</h2>

    <div class="pod-grid">

      <div class="pod-field pod-field--full" *ngIf="isTagsVisible">
        <one-select
          #tagsSelect
          [config]="tagsSelectConfig"
          [dataSource]="selectSources[F.TAGS]"
          [label]="LABELS[F.TAGS]"
          [multiple]="true"
          (selectionChanged)="onTagsChange($event)"
        ></one-select>
      </div>

      <div class="pod-field pod-field--full" *ngIf="isRequestReasonVisible"
           [class.pod-field--error]="isInvalid(F.REQUEST_REASON)">
        <one-select
          #requestReasonSelect
          [config]="selectConfig"
          [dataSource]="selectSources[F.REQUEST_REASON]"
          [label]="LABELS[F.REQUEST_REASON]"
          (selectionChanged)="onSelectChange(F.REQUEST_REASON, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.REQUEST_REASON)">*Required</span>
      </div>

      <div class="pod-field pod-field--full" [class.pod-field--error]="isInvalid(F.DETAIL_BRIEF)">
        <textarea
          class="pod-textarea"
          [formControlName]="F.DETAIL_BRIEF"
          placeholder="Brief summary of the reason for this purchase order..."
          rows="4"
          maxlength="300"
        ></textarea>
        <div class="pod-textarea-meta">
          <span class="pod-field__error" *ngIf="isInvalid(F.DETAIL_BRIEF)">*Required</span>
          <span class="pod-char-count" [class.pod-char-count--near]="detailBriefLength >= 270">
            {{ detailBriefLength }}/300
          </span>
        </div>
      </div>

    </div>
  </div>
</ng-template>
